import { CaretDownOutlined, CheckOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import Selection from './Selection';

export interface Preset {
  name: string;
  gradientOpacity: string;
  specularPower: string | number;
  scalarOpacity: string;
  id: string;
  specular: string | number;
  references?: string | number;
  shade: string | number;
  ambient: string | number;
  colorTransfer: string;
  selectable: string | boolean;
  diffuse: string | number;
  interpolation: string | number;
  effectiveRange: string;
}

type IVRPresetSelectorProps = {
  presets: Preset[];
  selectedPreset: string;
  onChange?: (p: string) => void;
};

const VRPresetSelector = ({
  presets,
  selectedPreset,
  onChange,
}: IVRPresetSelectorProps): JSX.Element => {
  return (
    <Selection
      size="small"
      popupClassName="dropdown-options-dark vindr-dropdown"
      menuItemSelectedIcon={<CheckOutlined />}
      suffixIcon={<CaretDownOutlined />}
      style={{
        width: 190,
        position: 'absolute',
        bottom: 15,
        right: '50%',
        transform: 'translateX(50%)',
      }}
      value={selectedPreset}
      onChange={onChange}
    >
      {presets.map((preset) => (
        <Select.Option key={preset.id} value={preset.id}>
          {preset.name}
        </Select.Option>
      ))}
    </Selection>
  );
};

export default VRPresetSelector;
